import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  
    theme: {
      primary: '#262d47',
      secondary: '#f75314'
    },

  rtl:true,
  icons: {
    iconfont: "fa"
  }
});
